var map = {
	"./AirWaterAndRocks": [
		27231,
		7231
	],
	"./AirWaterAndRocks.json": [
		27231,
		7231
	],
	"./Animals": [
		798,
		798
	],
	"./Animals.json": [
		798,
		798
	],
	"./EarthAndUniverse": [
		62171,
		2171
	],
	"./EarthAndUniverse.json": [
		62171,
		2171
	],
	"./FamilyAndFestivals": [
		45151,
		5151
	],
	"./FamilyAndFestivals.json": [
		45151,
		5151
	],
	"./Food": [
		54221,
		4221
	],
	"./Food.json": [
		54221,
		4221
	],
	"./GoodHabitsAndSafetyRules": [
		93317,
		3317
	],
	"./GoodHabitsAndSafetyRules.json": [
		93317,
		3317
	],
	"./HousingAndClothing": [
		51145,
		1145
	],
	"./HousingAndClothing.json": [
		51145,
		1145
	],
	"./HumanBody": [
		55994,
		5994
	],
	"./HumanBody.json": [
		55994,
		5994
	],
	"./Plants": [
		60059,
		59
	],
	"./Plants.json": [
		60059,
		59
	],
	"./TransportAndCommunication": [
		51905,
		1905
	],
	"./TransportAndCommunication.json": [
		51905,
		1905
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36552;
module.exports = webpackAsyncContext;